<template>
	<div class="pre_menu_top" v-show="show_top_menu">
		<!--    <ul>
      <li v-bind:id="'menu_top' + item.id" v-for="(item, index) in menu" :key="index">
        <div class="menu_top_img">
          <img src="../../assets/image/shan1.png" @click="fun_noshow_menu(item.id)" />
        </div>
        <span class="btn_menu_one" @click="gochildren(item.id,item.path,item.parm)">
          {{ item.name }}
        </span>
      </li>
    </ul> -->

		<el-tabs v-model="select_menu" type="card" closable @tab-remove="remove_menu" @tab-click="fun_sel_menu">
			<el-tab-pane class="top-menu" v-for="item in menu" :key="item.id" :label="item.name" :name="item.id">
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import {
		GoUrl,
		Message,
		isJson
	} from '@/utils/method.js';
	import {
		GetShort,
		SetShort,
		DelShort
	} from "@/utils/localstore.js";

	export default {
		name: 'pre_menu_top',
		data() {
			return {
				msg_obj: {},
				fullscreenLoading: false,
				menu: [],

				show_top_menu: true,
				select_menu: '',
			};
		},
		watch: {
			menu: function(val) {
				// console.log('当前点击菜单数量', val);
				this.menu_length(val);
			}
		},
		created: function() {
			if (this.menu.length == 0) {
				this.show_top_menu = false;
			}
		},
		methods: {
			menu_length:function(d){
				if (d.length > 0) {
					this.show_top_menu = true;
				}else{
					this.$emit("my-menu-top", d); //强制刷新
				}
			},
			loadData: function(d) {
				// console.log('刷新横向菜单');
				// console.log(d);
				this.menu = [];
				this.menu = d;
				var tid = 0;
				for (var i = 0; i < this.menu.length; i++) {
					if (this.menu[i].flag == '1') {
						tid = this.menu[i].id;
						this.select_menu = tid;
						break;
					}
				}
			},
			remove_menu: function(del_index) {
				// console.log('del_select=' + del_index);
				// console.log('sel_select=' + this.select_menu);
				let tabs = this.menu;
				let activeName = this.select_menu;

				if (activeName === del_index) {
					tabs.forEach((tab, index) => {

						if (tab.id === del_index) {
							let nextTab = tabs[index + 1] || tabs[index - 1];
							if (nextTab) {
								activeName = nextTab.name;
								// console.log(nextTab);
								this.$router.push({
									path: "/" + nextTab.path,
									query: nextTab.parm
								}).catch(err => err);
								this.$emit("my-menu-top", this.menu); //强制刷新

							}
						}
					});
				}


				for (let i = 0; i < this.menu.length; i++) {
					if (this.menu[i].id == del_index) {
						this.menu.splice(i, 1);
						break;
					}
				}



			},
			fun_sel_menu: function(e) {
				// console.log(this.menu);
				// console.log('index='+ e.index);
				// console.log(this.menu[e.index]);

				this.$router.push({
					path: "/" + this.menu[e.index].path,
					query: this.menu[e.index].parm
				}).catch(err => err);

				this.$emit("my-menu-top", this.menu); //强制刷新
			},
			gochildren: function(tid, path, parm) {
				// console.log(path);
				// console.log(parm);
				// console.log('子菜单id='+tid);
				this.select_menu = tid;
				// var parm;

				// var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I',
				//   'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
				// ];
				// var maxLength = 4;
				// var paramsAccount = '';
				// for (var i = 0; i < maxLength; i++) {
				//   var id = Math.ceil(Math.random() * 35);
				//   paramsAccount += chars[id];
				// }

				// if (isJson(parm)) {
				//   parm['random'] = paramsAccount;
				// }


				// res 为随机字符串,下面是跳转：
				// console.log('跳转目标 == '+path);
				if (path === undefined || path == null || String(path) == 'undefined') {
					this.$router.push({
						path: "/home",
						query: parm
					}).catch(err => err);
				} else {

					this.$router.push({
						path: "/" + path,
						query: parm
					}).catch(err => err);
				}

				this.$emit("my-menu-top", this.menu);
				// this.changStyle(tid);
			},
			changStyle: function(tid) {
				// 颜色保留
				this.$nextTick(function() {
					for (var i = 0; i < this.menu.length; i++) {
						if (this.menu[i].id == tid) {
							document.getElementById('menu_top' + tid).style.background = '#a3d5ff';
							document.getElementById('menu_top' + tid).style.fontWeight = '500';
						} else {
							document.getElementById('menu_top' + this.menu[i].id).style.background = '#d2e0f2';
							document.getElementById('menu_top' + this.menu[i].id).style.fontWeight = 'normal';
						}

					}
				});
			},
			fun_noshow_menu: function(tid) {
				// console.log('len=' + this.menu.length);
				// console.log('删除前='+this.menu.length)
				var td = [];
				var del_num = 0;
				for (var i = 0; i < this.menu.length; i++) {
					if (this.menu[i].id != tid) {
						var o = {};
						o.id = this.menu[i].id;
						o.name = this.menu[i].name;
						o.path = this.menu[i].path;
						o.parm = this.menu[i].parm;
						o.flag = this.menu[i].flag;
						td.push(o);
					} else {
						del_num = i;
					}
				}

				this.menu = [];
				this.menu = td;
				let gid = 0;
				gid = del_num - 1;
				// console.log(this.menu);
				// console.log('删除后='+this.menu.length)
				if (gid >= 0) {
					this.gochildren(this.menu[gid].id, this.menu[gid].path);
				} else {
					this.$router.push({
						path: "/home",
						query: {
							"random": ((Math.random() + '').substring(0, 4))
						}
					}).catch(err => err);
				}

				this.$emit("my-menu-top", this.menu);

			}
		}
	};
</script>

<style scoped>
	.el-tabs__header{
		margin: 0px;
	}
	.pre_menu_top>ul {
		list-style-type: none;
		margin: 0;
		padding: 0;
	}

	.menu_top_img {
		width: 14px;
		height: 14px;
		overflow: hidden;
		position: relative;
		margin-right: -10px;
		margin-top: -8px;
		right: 0px;
		float: right;
	}

	.menu_top_img>img {
		position: relative;
		width: 100%;
		height: 100%;
	}

	/*  .menu_top_img>img:hover {
    cursor: pointer;
  } */

	.pre_menu_top>ul>li {
		cursor: pointer;
		display: inline-block;
		border: 1px solid #d2e0f2;
		background: #d2e0f2;
		margin-left: 8px;
		padding-left: 5px;
		padding-right: 5px;
		padding-top: 2px;
		padding-bottom: 5px;
		border-radius: 8px 8px 0px 0px;
		width: 128px;
		text-align: center;
	}

	.pre_menu_top>ul>li>.btn_menu_one {
		display: block;
		text-align: center;
		word-break: keep-all;
		overflow: hidden;
		font-size: 16px;
		font-weight: 500;
		font-family: "agency fb";
	}

	.pre_menu_top>ul>li:hover {
		font-weight: 500;
		/* background: #0582ca !important; */
	}
	
	.top-menu:hover{
		background: #dddddd !important;
	}
</style>
